import { useRef, useState , useEffect, Fragment } from "react";
import Config from "../../Config";

import empty_user from "../../empty_user.png";
import ico_write from "../../write.png";
import ico_hide from "../../gohide.png";

function ChatWidget(props)
{

            const [refreshView, setRefreshView] = useState(props.userData.refreshView);

            const [tab, setTab] = useState(null);

            const [itemSelected, setItemSelected] = useState(1);

            const [fraza,setFraza] = useState("");


            const [view, setView] = useState(props.view);



            const clickTab = (e) => {

                var t = e.target.getAttribute("atr-tab");
                setItemSelected(t);
            }


            const onSearch= (e) => {
                var x = e.target.value;

                x = x.toLowerCase();

                setFraza(x);
            }

            const getTab = () => {
            
        
                props.mainView.setProgress(-2);

            

                fetch( Config.url + '/rest_v1_msg,chat_list', {
                    method: 'POST', 
                    body: JSON.stringify({}), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                        '_sec_key_': Config.genXKey() ,
                    }
                })
                .then(res => res.json() )
                .then(res => { 

                            props.mainView.setProgress(-1);        
                            if(res._sys_ == undefined)
                            {
                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                            }else    
                            {
                                setTab(res.result);            
                            
                            }
                } )
                .catch(err => {          
                            props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                            props.mainView.setProgress(-1);
                });
                        

                return false;
            }


            const openChat = (e) => {
            
                changeView();
                
                var typ = e.currentTarget.getAttribute('typ');
                var typId = e.currentTarget.getAttribute('typId');        
                var title = e.currentTarget.getAttribute('title');        
                props.mainView.openChat(title, typ, typId);
            }



            const changeView = () => {
                if(view == "list")
                {
                    setView("iko");
                }else setView("list");
            }



            if(tab == null)
                {
                    setTab([]);
                    getTab();
                    return <div>
                        ...
                    </div>
                }
            
            
                if(refreshView != props.userData.refreshView)
                    {         
                        setRefreshView( props.userData.refreshView);
                        setTab(null);                
                    }
                

            if(tab.opiekunowie == null)
            {
                return <div>...</div>
            }


            if(view != "list")
            {
                return <div className="chat_widget_ico">
                        <img src={ico_write} onClick={changeView} />
                </div>
            }


    return <div className="chat_widget">


                <div className="chat_gohide">
                   <img src={ico_hide} onClick={changeView} />
                </div>

                <br/>

                <div className="wchat_search">
                      <input type="text" value={fraza} onChange={onSearch} placeholder="Szukaj: " />
                </div>

            


                    <div className="chat_title">Kadra</div>     
                        <div className="chat_scroll">
                         <table className="chat_persons">
                                {
                                    tab.opiekunowie.map( (row, ix )  => {

                                        var filter = true;


                                        if(fraza.length > 2)
                                        {
                                            filter = false;
                                        

                                            var c1 = row.nazwisko.toLowerCase();
                                            var c2 = row.imie.toLowerCase();

                                            if(c1.includes(fraza) || c2.includes(fraza) ) filter = true;

                                            console.log("sdfsadf", filter);

                                        }


                                        if(filter == false) return null;


                                        var ostD = "";
                                        if(row.ostatnia_aktywnosc.length > 3)
                                        {
                                            ostD = "Ostatnio aktywny: " + row.ostatnia_aktywnosc;
                                        }

                                        var aw = empty_user;
                                                                                    
                                        if(row.awatar.length > 10)
                                        {
                                                aw = "data:image/png;base64," + row.awatar;
                                        }

                                    

                                        return <tr typ="px_group" typId={row.id} title={row.nazwisko + " " + row.imie} onClick={openChat}>
                                                    <td className="c_awatar"><img src={aw} /></td>
                                                    <td className="c_name">{row.nazwisko + " " + row.imie}</td>                                                  
                                            </tr>

                                    })
                                }           
                                </table>
                        </div>
               
                  

                                     {
                                             tab.grupy.map( (row, ix) => {

                                                if(row.dzieci.length == 0) 
                                                {
                                                    return null;
                                                }

                                                return <Fragment>

                                                            <div className="chat_title">{row.nazwa} </div>

 
                                                            <div className="chat_scroll">  
                                                              
                                                               <table className="chat_persons">
                                                                {
                                                                    row.dzieci.map( (dz, dix) => {

                                                                            return <Fragment>
                                                                                
                                                                                    {
                                                                                        dz.rodzice.map(  (rdz, rix) => {


                                                                                            var filter = true;


                                                                                            if(fraza.length > 2)
                                                                                            {
                                                                                                filter = false;
                                                                                               
                                                    
                                                                                                var c1 = rdz.nazwisko.toLowerCase();
                                                                                                var c2 = rdz.imie.toLowerCase();
                                                    
                                                                                                if(c1.includes(fraza) || c2.includes(fraza) ) filter = true;
                                                    
                                                                                                console.log("sdfsadf", filter);
                                                    
                                                                                            }
                                                    
                                                    
                                                                                            if(filter == false) return null;


                                                                                            var aw = empty_user;
                                                                                    
                                                                                            if(rdz.awatar.length > 10)
                                                                                            {
                                                                                                aw = "data:image/png;base64," + rdz.awatar;
                                                                                            }


                                                                                            return <tr  typ="px_group" typId={rdz.id} title={rdz.nazwisko + " " + rdz.imie} onClick={openChat}>
                                                                                            <td className="c_awatar"><img src={aw} /></td>
                                                                                            <td className="c_name">{rdz.nazwisko + " " + rdz.imie}</td>
                                                                                            <td className="c_type">({dz.dziecko})</td>                                                                                        
                                                                                            </tr>

 

                                                                                        } )
                                                                                    }

                                                                            </Fragment>

                                                                    } ) 

                                                                }
                                                                </table>
                                                            </div>
                                                </Fragment>

                                                } )
                                            }

         
    </div>
}




export default ChatWidget;